import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import LazyLoad from "react-lazyload";

function Gallery() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getGallery();
      console.log("get Gallery Data",topperData)
      setData(topperData);
    };
    fetchData();
  }, []);

  useEffect(() => {
    console.log("events_data", data[0]);
  }, [data]);


  return (
    <>
      <div className="container-fluid animateMe" data-animation="fadeInUpBig">
          <div className="row">
            <div>
              <div className="col-lg-4 col-sm-6">
             <LazyLoad> <img
                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[0]}`}
                  className="img-fluid lg-mid"
                /></LazyLoad>
              </div>
              <div className="col-lg-4 col-sm-6">
                <LazyLoad><img
                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[1]}`}
                  className="img-fluid lg-small"
                /></LazyLoad>
                <LazyLoad><img
                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[2]}`}
                  className="img-fluid lg-small"
                /></LazyLoad>
              </div>
              <div className="col-lg-4">
                <LazyLoad><img
                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0]?.attachments[3]}`}
                  className="img-fluid lg-mid"
                /></LazyLoad>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="button">
                <a href="/gallery">VIEW ALL</a>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default Gallery;
